<template>
<div>
    <v-autocomplete
      v-model="select"
      :loading="loading"
      :items="customers"
      return-object
      :item-text="custLabel"
      :search-input.sync="search"
      flat
      :deletable-chips="false"
      label="Seleccione un cliente"
      clearable
      @click:clear="clearButton"
    >
        <template slot="no-data">
            Buscar clientes...
        </template>
        <template v-slot:selection="{ item/*, selected*/ }">
            <span class="blueGreyText font-weight-medium" v-text="item.no + ' - ' + item.name + ' (' + item.alias + ')'"></span>
            <!--v-chip
            :selected="selected"
            color="blue-grey"
            class="white--text"
            >
            <span v-text="item.no + ' - ' + item.name + ' (' + item.alias + ')'"></span>
            </v-chip-->
        </template>
        <template v-slot:item="{ item }">
            <v-list-tile-content>
            <v-list-tile-title>
                {{ item.no }} - {{ item.name }} {{ item.name2 }} 
                <span class="lightText"><span v-if="item.discounts.length">Dto {{ item.discounts[0].discount }}% - </span>Pago {{ item.payment }} </span> 
            </v-list-tile-title>
            <v-list-tile-sub-title> {{ item.alias }} - {{ item.customerPriceGroup }}</v-list-tile-sub-title>
            </v-list-tile-content>
        </template>
    </v-autocomplete>
</div>
</template>
<script>
import _ from 'lodash'
export default {
    name: 'listaClientes',
    data (){ 
        return {
            items: [],
            search: null,
            select: null,
        }
    },
    watch: {
        search (val) {
            val && val !== this.select && this.debouncedSearch(val)
        },
        select(val,oldVal){
            if (val && !oldVal){ 
                this.$store.commit('setCustomer',val);
            }
            else if (val && oldVal){
                this.$store.commit('setCustomer',val);
                this.$store.commit('resetTaskData');
            } else if (!val)
                this.select = oldVal;
        },
    },
    methods: {
        clearButton(){
            this.$store.state.custFilter = '';
            this.customers = [];
        },
        custLabel(item){
            return item.no + ' - ' + item.name + ' (' + item.alias + ')';
        },
        debouncedSearch: _.debounce(function (search) { this.doSearch(search); }, 300),
        doSearch(search) {
            if (search != ' - undefined (undefined)'){
                //Fix para la primera vez que se ejecute este codigo en un dispositivo nuevo
                this.loading = true;
                this.$store.state.custFilter = search;
                this.getCustomers();
            }
        },
    },
    computed: {
        /*search:{
            get(){
                return this.$store.state.custFilter;
            },
            set(value){
                this.$store.commit('setCustFilter',value);
            }
        },*/
        customer: {
            get(){
                return this.$store.state.customer;
            },
            set(value){
                this.$store.commit('setCustomer',value);
            }
        },
        customers: {
            get(){
                return this.$store.state.customers;
            },
            set(value){
                this.$store.commit('setCustomers',value);
            }
        },
        loading:{
          get(){
                return this.$store.state.activeAxiosComms.customer;
            },
          set(value){
              this.$store.commit('setCustomerLoading',value);
          } 
        },
        
    },
    mounted(){
        this.getCustomers();
        if (this.customer.no != ''){
            this.select = this.customer;
        }
    }
}
</script>
<style>
.lightText{
    font-size: small;
    color: gray;
}
.blueGreyText{
    color: #1e88e5;
}
</style>

